import { Seo } from "../../components/site/Seo";
import { PageHero, CtaBand, Btn, HotlineBtn } from "../../components/site/Kit";
import { Block, Related } from "../../components/fm/Blocks";
import { SERVICE_PAGES } from "../../content/fm";

export default function FmService({ slug }) {
  const p = SERVICE_PAGES[slug];
  return (
    <>
      <Seo />
      <PageHero testid={`fm-hero-${slug}`} eyebrow={p.eyebrow} title={p.title} intro={p.intro} image={p.image}>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Btn to="/contact" testid="fm-hero-talk">Talk to us</Btn>
          <HotlineBtn variant="outline" testid="fm-hero-hotline" />
        </div>
      </PageHero>
      {p.blocks.map((b, i) => <Block key={b.title} b={b} i={i} />)}
      <Related slugs={p.related} />
      <CtaBand
        title="Let's build a better FM model."
        copy="Talk to us about a single property, a specialist workstream or a complete nationwide solution. For emergencies, call the hotline now."
        secondary={<Btn to="/contact" variant="ghost" testid="fm-cta-contact">Talk to us →</Btn>}
      />
    </>
  );
}
